function stripSkuFromTitles() {
  console.log('[SKU CLEANER] Running stripSkuFromTitles()');

  const selectors = [
    '.card__title a',
    '.card__information .card__heading a',
    '.cart-item__details > span',
    '.product__title',
    '.cart-item__name',
    '.omgrfq_product_title a'
  ];

  selectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    console.log(`[SKU CLEANER] Found ${elements.length} elements for selector: ${selector}`);

    elements.forEach(el => {
      const originalText = el?.textContent?.trim();
      if (!originalText) {
        console.log(`[SKU CLEANER] Empty or missing text for element`, el);
        return;
      }

      const cleanedText = originalText.replace(/\s-\s[A-Z0-9\-]+$/, '');

      if (cleanedText !== originalText) {
        console.log(`[SKU CLEANER] Updating text:\nOriginal: "${originalText}"\nCleaned: "${cleanedText}"`);
        el.textContent = cleanedText;
      } else {
        console.log(`[SKU CLEANER] No change needed for: "${originalText}"`);
      }
    });
  });

  console.log('[SKU CLEANER] stripSkuFromTitles() complete\n');
}

// Run once on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('[SKU CLEANER] DOMContentLoaded event fired');
    stripSkuFromTitles();
  });
} else {
  console.log('[SKU CLEANER] DOM already loaded');
  stripSkuFromTitles();
}

// Support Shopify section reloads (theme editor or dynamic section loads)
document.addEventListener('shopify:section:load', () => {
  console.log('[SKU CLEANER] shopify:section:load event fired');
  stripSkuFromTitles();
});
document.addEventListener('shopify:section:select', () => {
  console.log('[SKU CLEANER] shopify:section:select event fired');
  stripSkuFromTitles();
});

// Replace $0.00 AUD with "Price on application"
function replaceZeroPrices() {
  // Find all price elements
  const priceElements = document.querySelectorAll('.price-item');
  
  priceElements.forEach(element => {
    const priceText = element.textContent.trim();
    
    // Check if the price is exactly $0.00 AUD (case insensitive)
    if (priceText.match(/^\$0\.00\s*AUD$/i)) {
      element.textContent = 'Price on application';
      
      // Optional: Add a class for custom styling
      element.classList.add('price-on-application');
    }
  });
}

// Run the function when the page loads
document.addEventListener('DOMContentLoaded', replaceZeroPrices);

// Also run when the page content changes (for AJAX updates)
// This is useful if Shopify updates prices dynamically
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      // Check if any new price elements were added
      const hasNewPriceElements = Array.from(mutation.addedNodes).some(node => 
        node.nodeType === 1 && (
          node.classList?.contains('price-item') || 
          node.querySelector?.('.price-item')
        )
      );
      
      if (hasNewPriceElements) {
        replaceZeroPrices();
      }
    }
  });
});

// Start observing changes to the document
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Optional: Add some basic CSS styling for the "Price on application" text
const style = document.createElement('style');
style.textContent = `
  .price-on-application {
    font-style: italic;
    color: #666;
  }
`;
document.head.appendChild(style);